import React, { useContext, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import IntlMessages from '../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import GridContainer from '../../@jumbo/components/GridContainer';

import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Box, fade } from '@material-ui/core';
import { AuhMethods } from '../../services/auth';
import ContentLoader from '../../@jumbo/components/ContentLoader';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CurrentAuthMethod } from '../../@jumbo/constants/AppConstants';
import { NavLink } from 'react-router-dom';
import AuthWrapper from './AuthWrapper';
import { THEME_TYPES } from '../../@jumbo/constants/ThemeOptions';
import AppContext from '../../@jumbo/components/contextProvider/AppContextProvider/AppContext';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: 'white',
  },
  textFieldRoot: {
    color: 'white',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'white',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'white',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
      '& fieldset': {
        borderColor: 'white',
      },
    },
  },
  formcontrolLabelRoot: {
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  },
}));
//variant = 'default', 'standard'
const LoginMilenij2 = ({ method = CurrentAuthMethod, variant = 'milenij', wrapperVariant = 'bgColor2' }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hotelCode, setHotelCode] = useState('');
  const [demoCode, setDemoCode] = useState('DEMO');
  const [myMode, setmyMode] = useState(1);
  const [demoEmail, setDemoEmail] = useState('DEMO');
  const [demoPassword, setDemoPassword] = useState('DEMO');
  const dispatch = useDispatch();
  const classes = useStyles({ variant });

  const date = new Date();
  if (variant == 'milenij') {
    //   setThemeType(THEME_TYPES.DARK);
  }

  const onSubmit = () => {
    if (variant === 'standard' && email != '' && password != '')
      dispatch(AuhMethods[method].onLogin({ email, password, hotelCode, myMode }));
    if (variant === 'milenij' && email != '' && password != '' && hotelCode != '')
      dispatch(AuhMethods[method].onLogin({ email, password, hotelCode, myMode }));
  };

  const onSubmit2 = () => {
    if (variant === 'milenij') dispatch(AuhMethods[method].onLogin({ demoEmail, demoPassword, demoCode, myMode }));
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      {variant === 'default' ? (
        <Box className={classes.authThumb}>
          <CmtImage src={'/images/auth/login-img.png'} />
        </Box>
      ) : null}
      <Box className={classes.authContent}>
        <Box mb={7}>
          <GridContainer>
            <Grid
              container
              xs={12}
              sm={12}
              xl={12}
              direction="row"
              alignContent="center"
              alignItems="center"
              justify="center">
              <img
                src={variant === 'standard' ? '/images/logo-wbp.png' : '/images/logo-milenij2.png'}
                style={{ maxHeight: '96px' }}
              />
            </Grid>
            <Grid
              container
              xs={12}
              sm={12}
              xl={12}
              direction="row"
              alignContent="center"
              alignItems="center"
              justify="center">
              <Typography component="div" variant="h1" className={classes.titleRoot}>
                {variant === 'standard' ? 'Login' : 'Milenij Gastro Mobile'}
              </Typography>
            </Grid>
          </GridContainer>
        </Box>

        <form>
          <Box mb={2}>
            <TextField
              label={variant === 'standard' ? <IntlMessages id="appModule.email" /> : 'Korisničko ime'}
              fullWidth
              onChange={event => setEmail(event.target.value)}
              defaultValue={email}
              margin="normal"
              variant="standard"
              className={classes.textFieldRoot}
              inputProps={{ style: { color: 'white' } }}
              InputLabelProps={{
                style: { color: 'white' },
              }}
            />
          </Box>
          <Box mb={2}>
            <TextField
              type="password"
              label={variant === 'standard' ? <IntlMessages id="appModule.password" /> : 'Lozinka'}
              fullWidth
              onChange={event => setPassword(event.target.value)}
              defaultValue={password}
              margin="normal"
              variant="standard"
              className={classes.textFieldRoot}
              inputProps={{ style: { color: 'white' } }}
              InputLabelProps={{
                style: { color: 'white' },
              }}
            />
          </Box>
          {variant === 'milenij' ? (
            <Box mb={2}>
              <TextField
                label={variant === 'standard' ? <IntlMessages id="appModule.hotelCode" /> : 'Šifra objekta'}
                fullWidth
                onChange={event => setHotelCode(event.target.value)}
                defaultValue={hotelCode}
                margin="normal"
                variant="standard"
                inputProps={{ style: { color: 'white' } }}
                InputLabelProps={{
                  style: { color: 'white' },
                }}
                className={classes.textFieldRoot}
              />
            </Box>
          ) : null}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
            {variant == 'standard' && (
              <FormControlLabel
                className={classes.formcontrolLabelRoot}
                control={<Checkbox name="checkedA" />}
                label="Remember me"
              />
            )}
            <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              {variant === 'standard' ? (
                <NavLink to="/forgot-password">
                  <IntlMessages id="appModule.forgotPassword" />
                </NavLink>
              ) : null}
            </Box>
          </Box>

          <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
            {variant === 'milenij' && (
              <Button
                onClick={onSubmit}
                variant="contained"
                style={{
                  color: 'white',
                  backgroundColor: '#e60073',
                  borderColor: '#e60073',
                  padding: '18px 36px',
                }}
                fullWidth>
                Prijava
              </Button>
            )}

            {variant === 'standard' && (
              <Button onClick={onSubmit} variant="contained" color="primary">
                <IntlMessages id="appModule.signIn" />
              </Button>
            )}

            <Box component="p" fontSize={{ xs: 12, sm: 16 }}>
              {variant === 'standard' ? (
                <a href="https://webbookingpro.com/pricing">
                  <IntlMessages id="signIn.signUp" />
                </a>
              ) : null}
            </Box>
          </Box>
          {variant === 'milenij' ? (
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={5}>
              <Button
                onClick={onSubmit2}
                variant="contained"
                style={{
                  color: 'white',
                  backgroundColor: '#660033',
                  borderColor: '#660033',
                  padding: '18px 36px',
                }}
                fullWidth>
                Istražite demo
              </Button>
            </Box>
          ) : null}
        </form>

        {dispatch(AuhMethods[method].getSocialMediaIcons())}
        <Box display="flex" alignItems="center" justifyContent="center" mb={5}>
          {variant === 'standard' ? (
            <small>Copyright© {date.getFullYear()} Alpha Software Ltd.</small>
          ) : (
            <small>Powered by WebBookingPro</small>
          )}
        </Box>
        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default LoginMilenij2;
